import React, { useCallback, useEffect, useRef, useState } from "react";
import { FaStop, FaTimes, FaVolumeUp } from "react-icons/fa";
import {
  ensureHelpVoicesLoaded,
  isHelpSpeechSupported,
  speakHelpText,
  stopHelpSpeech,
} from "../helpers/helpTextToSpeech";
import "./SidebarToolInfoModal.css";

function SidebarToolInfoModal({ title, onClose, children, speakText }) {
  const bodyRef = useRef(null);
  const [speaking, setSpeaking] = useState(false);
  const [speechSupported] = useState(isHelpSpeechSupported);

  const handleClose = useCallback(() => {
    stopHelpSpeech();
    setSpeaking(false);
    onClose();
  }, [onClose]);

  useEffect(() => {
    const cleanupVoices = ensureHelpVoicesLoaded(() => {});
    return () => {
      cleanupVoices();
      stopHelpSpeech();
    };
  }, []);

  const resolveSpeakText = useCallback(() => {
    if (speakText && speakText.trim()) {
      return speakText.trim();
    }
    if (!bodyRef.current) return "";
    return bodyRef.current.innerText.replace(/\s+/g, " ").trim();
  }, [speakText]);

  const handleSpeak = () => {
    const text = resolveSpeakText();
    if (!text) return;

    const started = speakHelpText(text, {
      onStart: () => setSpeaking(true),
      onEnd: () => setSpeaking(false),
      onError: () => setSpeaking(false),
    });

    if (!started) {
      setSpeaking(false);
    }
  };

  const handleStop = () => {
    stopHelpSpeech();
    setSpeaking(false);
  };

  return (
    <div
      className="sidebar-tool-info-backdrop"
      onClick={handleClose}
      role="presentation"
    >
      <div
        className="sidebar-tool-info-modal"
        onClick={(event) => event.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="sidebar-tool-info-title"
      >
        <div className="sidebar-tool-info-header">
          <h3 id="sidebar-tool-info-title">{title}</h3>
          <button
            type="button"
            className="sidebar-tool-info-close"
            onClick={handleClose}
            aria-label="Fechar"
          >
            <FaTimes />
          </button>
        </div>
        <div className="sidebar-tool-info-body" ref={bodyRef}>
          {children}
        </div>
        {speechSupported && (
          <div className="sidebar-tool-info-footer">
            {!speaking ? (
              <button
                type="button"
                className="btn btn-default sidebar-tool-info-speak-btn"
                onClick={handleSpeak}
              >
                <FaVolumeUp style={{ marginRight: 6 }} />
                Ouvir explicação
              </button>
            ) : (
              <button
                type="button"
                className="btn btn-warning sidebar-tool-info-speak-btn"
                onClick={handleStop}
              >
                <FaStop style={{ marginRight: 6 }} />
                Parar leitura
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default SidebarToolInfoModal;
